import { Badge, Box, Heading, Stack, Text } from "@chakra-ui/react"
import { useTranslation } from "react-i18next"

import { useColorMode } from "@/components/ui/color-mode"
import { Radio, RadioGroup } from "@/components/ui/radio"
import { useSemanticColors } from "@/hooks/useSemanticColors"
import { useTemperatureUnit } from "@/hooks/useTemperatureUnit"
import { type UIScale, useUIScale } from "@/hooks/useUIScale"

const Appearance = () => {
  const { colorMode, setColorMode } = useColorMode()
  const { unit, setUnit } = useTemperatureUnit()
  const { scale, setScale } = useUIScale()
  const { t } = useTranslation("settings")
  const sc = useSemanticColors()

  return (
    <>
      <Heading size="md" color={sc.heading} mb={4}>
        {t("appearance.title")}
      </Heading>
      <RadioGroup
        onValueChange={(e) => setColorMode(e.value)}
        value={colorMode}
      >
        <Stack>
          <Radio value="system" colorScheme="teal">
            {t("appearance.system")}
            <Badge ml="1" colorScheme="teal">
              {t("appearance.default")}
            </Badge>
          </Radio>
          <Radio value="light" colorScheme="teal">
            {t("appearance.light")}
          </Radio>
          <Radio value="dark" colorScheme="teal">
            {t("appearance.dark")}
          </Radio>
        </Stack>
      </RadioGroup>

      <Box mt={8}>
        <Heading size="md" color={sc.heading} mb={2}>
          {t("appearance.temperatureUnit")}
        </Heading>
        <Text color={sc.textMuted} fontSize="sm" mb={3}>
          {t("appearance.temperatureUnitDesc")}
        </Text>
        <RadioGroup onValueChange={(e) => setUnit(e.value as any)} value={unit}>
          <Stack>
            <Radio value="celsius" colorScheme="teal">
              {t("appearance.celsius")}
              <Badge ml="1" colorScheme="teal">
                {t("appearance.default")}
              </Badge>
            </Radio>
            <Radio value="fahrenheit" colorScheme="teal">
              {t("appearance.fahrenheit")}
            </Radio>
            <Radio value="both" colorScheme="teal">
              {t("appearance.bothUnits")}
            </Radio>
          </Stack>
        </RadioGroup>
      </Box>

      <Box mt={8}>
        <Heading size="md" color={sc.heading} mb={2}>
          {t("appearance.uiScale")}
        </Heading>
        <Text color={sc.textMuted} fontSize="sm" mb={3}>
          {t("appearance.uiScaleDesc")}
        </Text>
        <RadioGroup
          onValueChange={(e) => setScale(Number(e.value) as UIScale)}
          value={String(scale)}
        >
          <Stack>
            <Radio value="80" colorScheme="teal">
              {t("appearance.uiScale80")}
            </Radio>
            <Radio value="90" colorScheme="teal">
              {t("appearance.uiScale90")}
            </Radio>
            <Radio value="100" colorScheme="teal">
              {t("appearance.uiScale100")}
              <Badge ml="1" colorScheme="teal">
                {t("appearance.default")}
              </Badge>
            </Radio>
            <Radio value="110" colorScheme="teal">
              {t("appearance.uiScale110")}
            </Radio>
          </Stack>
        </RadioGroup>
      </Box>
    </>
  )
}
export default Appearance
